import { createSelector } from 'reselect';
import {
  ISubmitConfig,
  GlobalConfigState,
} from '../reducers/globalConfigReducer';

import { RootStore } from '../reducers/index';

const globalConfigStateSelector = createSelector(
  (state: RootStore) => state.globalConfig,
  (globalConfigState: GlobalConfigState) => globalConfigState,
);

export const accentColorSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.accentColor,
);

export const backgroundImageSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.backgroundImage,
);

export const primaryColorSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.primaryColor,
);

export const primaryTextColorSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.primaryTextColor,
);

export const secondaryTextColorSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) =>
    globalConfigState.secondaryTextColor,
);

export const introSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.intro,
);

export const footerSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.footer,
);

export const headerSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.header,
);

export const languagesSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.languages,
);

export const defaultLanguageSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.defaultLanguage,
);

export const defaultCountryPhoneCodeSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) =>
    globalConfigState.defaultCountryPhoneCode,
);

export const hideLanguagesFlagsSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) =>
    globalConfigState.hideLanguagesFlags,
);

export const showMyAccreditationSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) =>
    globalConfigState.showMyAccreditation,
);

export const submitConfigSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.submitConfig,
);

export const showSummarySelector = createSelector(
  submitConfigSelector,
  (submitConfig: ISubmitConfig | null) => submitConfig?.showSummary,
);

export const summaryTextSelector = createSelector(
  submitConfigSelector,
  (submitConfig: ISubmitConfig | null) => submitConfig?.summaryText,
);

export const stepSubmitOnSelector = createSelector(
  submitConfigSelector,
  (submitConfig: ISubmitConfig | null) => submitConfig?.stepSubmitOn,
);

export const projectIdSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.projectId,
);

export const printLayoutIdSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.printLayoutId,
);

export const formTypeSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.formType,
);

export const formDefIdSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.formDefId,
);

export const submitResultScreensSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) =>
    globalConfigState.submitResultScreens,
);

export const textsOverwritingsSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) => globalConfigState.textsOverwritings,
);

export const quotaExceededMessageSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) =>
    globalConfigState.quotaExceededMessage,
);

export const summaryPageFieldsFromAccountSelector = createSelector(
  globalConfigStateSelector,
  (globalConfigState: GlobalConfigState) =>
    globalConfigState.summaryPageFieldsFromAccount,
);
